/* NOVAIRE cart drawer — Shopify Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js).
   The drawer markup is rendered server-side by the `cart-drawer` section; after any
   cart mutation we re-fetch that section via the Section Rendering API and swap it in. */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var openAfterRender = false;
  var pendingChange = false;
  var renderSeq = 0;

  function root() { return document.getElementById('nv-cart-drawer-root'); }
  function drawer() { return document.getElementById('nv-cart-drawer'); }

  function updateCounts(count) {
    document.querySelectorAll('[data-nv-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    var close = d.querySelector('.nv-drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  function isOpen() {
    var d = drawer();
    return d && !d.hasAttribute('hidden');
  }

  function renderSection(callback) {
    var seq = ++renderSeq;
    fetch(window.location.pathname + '?sections=' + SECTION_ID)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (seq !== renderSeq) {
          if (callback) callback();
          return;
        }
        var html = sections[SECTION_ID];
        if (!html || !root()) {
          if (callback) callback();
          return;
        }
        var wasOpen = isOpen();
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector('#nv-cart-drawer-root');
        if (fresh) root().replaceWith(fresh);
        if (wasOpen || openAfterRender) openDrawer();
        openAfterRender = false;
        if (callback) callback();
      })
      .catch(function () {
        openAfterRender = false;
        if (callback) callback();
      });
  }

  function refresh(open) {
    openAfterRender = !!open;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCounts(cart.item_count); })
      .catch(function () {});
    renderSection();
  }

  function changeLine(line, quantity) {
    // The steppers post absolute quantities baked into the rendered markup, so
    // hold further changes until the fresh drawer HTML has been swapped in.
    if (pendingChange) return;
    pendingChange = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCounts(cart.item_count);
        renderSection(function () { pendingChange = false; });
      })
      .catch(function () { pendingChange = false; });
  }

  function addFromForm(form) {
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (button) button.removeAttribute('aria-disabled');
        if (data && data.status) {
          var msg = form.querySelector('[data-nv-form-error]');
          if (msg) { msg.textContent = data.description || data.message; msg.removeAttribute('hidden'); }
          return;
        }
        refresh(true);
      })
      .catch(function () {
        if (button) button.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nv-product-form]');
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nv-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      return;
    }
    var close = e.target.closest('[data-nv-cart-close]');
    if (close) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var step = e.target.closest('[data-nv-line-qty]');
    if (step) {
      e.preventDefault();
      changeLine(parseInt(step.getAttribute('data-line'), 10), parseInt(step.getAttribute('data-nv-line-qty'), 10));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeDrawer();
  });

  window.NVCart = { open: openDrawer, close: closeDrawer, refresh: refresh };
})();
